var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1034C11 17.1034 10.069 16.8276 9.24137 16.2759C8.41379 15.7241 7.79309 15.0345 7.3793 14.1724L3.24137 7C2.3793 8.55172 2 10.2414 2 12C2 14.5172 2.82758 16.6896 4.44828 18.5517C6.06898 20.4138 8.10344 21.5172 10.5173 21.8966L13.4138 16.8621C13.1379 16.9655 12.6207 17.1034 12 17.1034Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86209 7.86207C9.7931 7.13793 10.8276 6.82758 12 6.82758H20.5862C19.6897 5.31035 18.4828 4.20687 16.9655 3.3448C15.4483 2.44828 13.7931 2 12 2C10.4483 2 8.96553 2.34484 7.62072 3C6.27592 3.65516 5.00002 4.6207 4.10345 5.86207L7.00002 10.6207C7.27588 9.51723 7.93103 8.58621 8.86209 7.86207Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2414 8.24121H15.4483C16.4483 9.24121 17.1379 10.5516 17.1379 11.9998C17.1379 13.0688 16.8276 14.0343 16.2414 14.9309L12.1035 21.9998C14.8276 21.9654 17.1724 20.9998 19.1035 19.0343C21.0345 17.0688 22 14.724 22 11.9998C22 10.724 21.7931 9.37914 21.2414 8.24121Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.20703C14.069 8.20703 15.7931 9.93117 15.7931 12.0001C15.7931 14.0691 14.069 15.7932 12 15.7932C9.93101 15.7932 8.20691 14.0691 8.20691 12.0001C8.20691 9.93113 9.93101 8.20703 12 8.20703Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.7818d3690158c5647f497e32c20680e9.svg";
export { ForwardRef as ReactComponent };